import type { TableRow } from "@prequel/shared-components";

import type { DatalakeResource } from "@/api/import/datalakes";
import { useListDatalakes } from "@/api/import/datalakes";
import ResourceTable, { type FilterField } from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { STORAGE_FILTER_OPTIONS } from "@/pages/import/DatalakesPage/storage";
import VendorBadge from "@/pages/import/DatalakesPage/VendorBadge";

const COLUMNS = ["Name", "Vendor", "Created"];

const FILTER_FIELDS: FilterField[] = [
  {
    key: "storage",
    label: "Vendor",
    queryParam: "storage",
    options: STORAGE_FILTER_OPTIONS,
  },
];

const mapDatalakeToRow = (dl: DatalakeResource): TableRow => ({
  id: dl.id,
  to: `/import/datalakes/${dl.id}`,
  cells: [
    { value: dl.name },
    { value: <VendorBadge storage={dl.storage} /> },
    { value: <Timestamp timestamp={dl.created_at} /> },
  ],
});

const DatalakesTable = () => (
  <ResourceTable<DatalakeResource>
    columns={COLUMNS}
    useQuery={useListDatalakes}
    rowMapper={mapDatalakeToRow}
    emptyMessage="No datalakes configured."
    filterFields={FILTER_FIELDS}
  />
);

export default DatalakesTable;
